import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { projetosPath, contratosRoute } from '../../library/Routes';
import { PUFVOperacionalPermissions } from '../../store/modules/permissions/PUFVOperacional';

const Main = () => {
  const history = useHistory();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath.includes('/cadastro')) return;

    const isPUFV = auth?.userPermissions?.id === PUFVOperacionalPermissions.id;
    const targetPath = isPUFV ? contratosRoute.path : projetosPath;

    history.push(targetPath);
  }, [auth, history]);

  return null;
};

export default Main;
